import { getTimezones } from './apiService';

export const getRemoteParsedTimezones = async () => {
  const res = await getTimezones();
  return Object.keys(res.data.data).map((key) => ({
    id: key,
    name: key + ' ' + res.data.data[key],
  }));
};
